import { useState, useEffect } from "react";

import { makeStyles, Grid, Typography } from "@material-ui/core";

import { KPIS } from "../constants";
import { TwentyYear } from "../../../components/units";
import { api, getPercent, requestDateFormat } from "../../../services";
import { ShaDowBox, CardBox } from "../../../components/boxes";
import { Icon, LinearProgress } from "../../../components/base";
import RocketImg from "../../../assets/images/dashboard/rocket.svg";

const useStyles = makeStyles((theme) => ({
  container: {
    flexWrap: "noWrap",
  },
  icon: {
    marginRight: theme.spacing(1.5),
  },
}));

export const NOIIncreaseKPI = ({ activeKpi, setActiveKpi, period, startDate, endDate }) => {
  const classes = useStyles();
  const [data, setData] = useState({});

  useEffect(() => {
    const getData = (url) => {
      api.get(url).then((resp) => setData(resp.data));
    };

    const getUrl = (period) => {
      let url = "praas/v1/dashboard/noi-increase/";
      if (period.name === "RANGE" && endDate) {
        url += `?from_date=${requestDateFormat(startDate)}&to_date=${requestDateFormat(endDate)}`;
        getData(url);
      } else if (["YTD", "Acc.", "20Y"].includes(period.name)) {
        url += `?date_filter=${period.filter}`;
        getData(url);
      }
    };

    getUrl(period);
  }, [period, startDate, endDate]);

  return (
    <Grid
      id="noi-increase-kpi"
      item
      style={{ flex: 1 }}
      onClick={() => setActiveKpi(KPIS.noi_increase)}
    >
      <ShaDowBox hoverable>
        <CardBox>
          <Grid className={classes.container} container>
            <Icon root={classes.icon} src={RocketImg} />
            <div>
              <Typography
                color={activeKpi === KPIS.noi_increase ? "primary" : "initial"}
                variant="h2"
                style={{ fontWeight: "bold" }}
              >
                {data.per_date || 0}%
              </Typography>
              <Typography>NOI Increase With Power Revenue</Typography>
            </div>
          </Grid>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item xs={7}>
              <LinearProgress
                active={activeKpi === KPIS.noi_increase}
                variant="determinate"
                value={getPercent(data.per_date, data.per_20y)}
              />
            </Grid>
            <Typography align="right">+{data.per_20y}%</Typography>
            <TwentyYear />
          </Grid>
        </CardBox>
      </ShaDowBox>
    </Grid>
  );
};
